module.exports = __webpack_public_path__ + "fdc9629779e58ce744eba4d85faf7fd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/y-vs-year-banner.png
// module id = 1875
// module chunks = 1